import script from "./word.vue?vue&type=script&setup=true&lang=js"
export * from "./word.vue?vue&type=script&setup=true&lang=js"

import "./word.vue?vue&type=style&index=0&id=716db464&lang=less&scoped=true"
import "./word.vue?vue&type=style&index=1&id=716db464&lang=css"

import exportComponent from "C:\\webproject\\mofa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716db464"]])

export default __exports__